export default __webpack_public_path__ + "static/media/luv3.2b71bdd0.mp3";